import FormattedMessage from 'I18n/components/FormattedMessage';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { ReadabilityIssuesCardList } from '../../sharedComponents/ReadabilityIssuesCardList';
import { jsx as _jsx } from "react/jsx-runtime";
export const GrammarView = ({
  auditResult
}) => {
  const {
    status,
    grammarIssues
  } = auditResult;
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.GRAMMAR"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.GRAMMAR"
    }),
    status: status,
    children: /*#__PURE__*/_jsx(ReadabilityIssuesCardList, {
      issues: grammarIssues
    })
  });
};